export class Ciudad {
    _id : String;
    provincia :string;
    cantones :Array<any>;
}